import { Formik } from "formik";
import React, { useState } from "react";
import { Form, Modal, ModalBody, ModalHeader } from "react-bootstrap";
import Mixpanel from "mixpanel-browser";
import Button from "../../form-components/Button";
import Fields from "../../form-components/Fields";
import Yup from "../../../validations/validationsLib";
import eyeline from "../../../assets/images/eyelineicn.svg";
import eye from "../../../assets/images/eyeicn.svg";
import { useDispatch, useSelector } from "react-redux";
import { changePassword } from "../../../features/profile-management/changePasswordSlice";
import { OK } from "../../../constants/statusCode";
import { showError, showSuccess } from "../../../utils/messageHelper";
import Loader from "../../../common/loader/Loader";

const UpdatePasswordModal = ({ toggleFunction, isVisible }) => {
  const { updatePasswordLoading } = useSelector((state) => ({
    updatePasswordLoading: state?.changePasswordReducer?.isLoading,
  }));

  const [togglePassword, setTogglePassword] = useState(false);
  const [toggleOldPassword, setToggleOldPassword] = useState(false);
  const [toggleConfirmPassword, setToggleConfirmPassword] = useState(false);
  const dispatch = useDispatch();

  return (
    <>
      {updatePasswordLoading ? (
        <Loader />
      ) : (
        <Modal
          data-bs-keyboard="false"
          onHide={toggleFunction}
          show={isVisible}
          className="modal fade editproject-popup add-user-modal update-password"
          centered={true}
          dialogClassName="common-modal"
        >
          <ModalHeader closeButton onHide={toggleFunction}>
            <h3 className="modal-title" id="Add_OrganizationLabel">
              Update Password
            </h3>
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={{
                old_password: "",
                new_password: "",
                confirmPassword: "",
              }}
              validationSchema={Yup.object().shape({
                old_password: Yup.string().required(
                  "Old password cannot be blank!"
                ),
                new_password: Yup.string().matches(
                  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,32}$/,
                  "Password should contains 8-32 characters. At least 1 digit, 1 special character, 1 uppercase letter & 1 lowercase letter."
                ).required(
                  "New password cannot be blank!"
                ),
                confirmPassword: Yup.string()
                  .oneOf(
                    [Yup.ref("new_password"), null],
                    "Password & confirm password must be same."
                  )
                  .required("Confirm password cannot be blank!"),
              })}
              onSubmit={async (values) => {
                delete values.confirmPassword;
                Mixpanel.track("Change password Button Clicked", {
                  Page: "Update Password Modal",
                });
                const { payload } = await dispatch(changePassword(values));
                if (payload.status === OK) {
                  showSuccess(payload?.data?.responseMessage);
                  toggleFunction();
                } else {
                  showError(payload?.response?.data?.responseMessage);
                }
              }}
            >
              {({
                values,
                handleChange,
                handleBlur,
                touched,
                isSubmitting,
                errors,
                handleSubmit,
                setFieldValue,
              }) => (
                <Form>
                  <div className="">
                    <div className="form-group form-grp-passsword">
                      <Fields
                        type={toggleOldPassword ? "text" : "password"}
                        placeholder="Old Password"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="old_password"
                        value={values.old_password}
                        className="form-control"
                        onChange={handleChange}
                      />
                      <span
                        className={`icon-${toggleOldPassword ? "Hide" : "Hide"
                          }`}
                        onClick={() => setToggleOldPassword(!toggleOldPassword)}
                      >
                        <img
                          className="eye-icn"
                          src={toggleOldPassword ? eye : eyeline}
                          alt="show password"
                        />
                      </span>
                    </div>
                    <div className="form-group form-grp-passsword">
                      <Fields
                        type={togglePassword ? "text" : "password"}
                        placeholder="Password"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="new_password"
                        value={values.new_password}
                        className="form-control"
                        onChange={handleChange}
                      />
                      <span
                        className={`icon-${togglePassword ? "Hide" : "Hide"}`}
                        onClick={() => setTogglePassword(!togglePassword)}
                      >
                        <img
                          className="eye-icn"
                          src={togglePassword ? eye : eyeline}
                          alt="show password"
                        />
                      </span>
                    </div>
                    <div className="form-group form-grp-passsword">
                      <Fields
                        type={toggleConfirmPassword ? "text" : "password"}
                        placeholder="Confirm Password"
                        touched={touched}
                        errors={errors}
                        onBlur={handleBlur}
                        name="confirmPassword"
                        value={values.confirmPassword}
                        className="form-control"
                        onChange={handleChange}
                      />
                      <span
                        className={`icon-${toggleConfirmPassword ? "Hide" : "Hide"
                          }`}
                        onClick={() =>
                          setToggleConfirmPassword(!toggleConfirmPassword)
                        }
                      >
                        <img
                          className="eye-icn"
                          src={toggleConfirmPassword ? eye : eyeline}
                          alt="show password"
                        />
                      </span>
                    </div>
                    <div className="text-start text-md-end add-user-modal-footer">
                      <Button
                        type="button"
                        className="btn btn-primary-md"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                      >
                        Update Password
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default UpdatePasswordModal;
